<template>
  <button type="button" class="btn btn-link text-primary" click.delegate="donwload()">
    <i class="fas fa-download"></i> Download
  </button>
</template>
